//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    page: { type: Number, required: true },
    pages: { type: Number, required: true },
    neighbours: { type: Number, default: 2 }
  },
  computed: {
    pageNumbers () {
      return this.$store.getters['review/pageNumbers'](this.page, this.pages, this.neighbours)
    }
  }
}
